import { useContext } from 'react';
import { AdminDashboardContext } from '../contexts';
import {
  useGuideStatusMetricsQuery,
  useGuideTierMetricsQuery,
  useMemoryConnectStatusMetricsQuery,
  useMemoryConnectTierMetricsQuery,
  useCcmPatientsByMinutesMetricsQuery,
  usePatientsInCareManagementMetricsQuery,
  usePatientsInServiceLinesQuery,
} from '@common/cache/queries/metrics';
import useUserStore from 'store/user.store';

export const useProgramCharts = () => {
  const { user } = useUserStore();
  const { filters } = useContext(AdminDashboardContext);
  const { interval, to_date, from_date, roles } = filters;

  const { data: patientsInCareManagement, isLoading: isLoadingCareManagement } =
    usePatientsInCareManagementMetricsQuery({
      interval,
      to_date,
      from_date,
      roles,
      supervisor_ids: filters.supervisor_ids,
      record_ids: filters.record_ids,
    });
  const { data: patientsInServiceLines, isLoading: isLoadingServiceLines } =
    usePatientsInServiceLinesQuery({
      interval,
      to_date,
      from_date,
      roles,
      supervisor_ids: filters.supervisor_ids,
      record_ids: filters.record_ids,
    });
  const { data: ccmPatientsByMinutes, isLoading: isLoadingCcm } =
    useCcmPatientsByMinutesMetricsQuery({
      interval,
      to_date,
      from_date,
      roles,
      supervisor_ids: filters.supervisor_ids,
      record_ids: filters.record_ids,
    });
  const { data: guideStatusesMetrics, isLoading: isLoadingGuideStatus } =
    useGuideStatusMetricsQuery({
      interval,
      to_date,
      from_date,
      roles,
      supervisor_ids: filters.supervisor_ids,
      record_ids: filters.record_ids,
    });
  const { data: guideTierMetrics, isLoading: isLoadingGuideTier } =
    useGuideTierMetricsQuery({
      interval,
      to_date,
      from_date,
      roles,
      supervisor_ids: filters.supervisor_ids,
      record_ids: filters.record_ids,
    });
  const { data: memoryConnectStatusMetrics, isLoading: isLoadingMcStatus } =
    useMemoryConnectStatusMetricsQuery({
      interval,
      to_date,
      from_date,
      roles,
      supervisor_ids: filters.supervisor_ids,
      record_ids: filters.record_ids,
    });
  const { data: memoryConnectTierMetrics, isLoading: isLoadingMcTier } =
    useMemoryConnectTierMetricsQuery({
      interval,
      to_date,
      from_date,
      roles,
      supervisor_ids: filters.supervisor_ids,
      record_ids: filters.record_ids,
    });

  const hasViewPermission = user?.permissions.includes('view_reports');

  return {
    hasViewPermission,
    ccmPatientsByMinutes,
    patientsInCareManagement,
    patientsInServiceLines,
    memoryConnectStatusMetrics,
    memoryConnectTierMetrics,
    guideStatusesMetrics,
    guideTierMetrics,
    isLoadingCareManagement,
    isLoadingServiceLines,
    isLoadingCcm,
    isLoadingGuideStatus,
    isLoadingGuideTier,
    isLoadingMcStatus,
    isLoadingMcTier,
  };
};
